<script>
	
</script>

<footer>
	<nav>
		<ul>
			<div>
				<li><a href="https://twitter.com/"><img src="./twitter.png" alt="twitter"></a></li>
				<li><a href="https://t.me/"><img src="./telegram.png" alt="telegram"></a></li>
			</div>
			<li class="email"><a href="mailto:akifsahinkorkmaz@outlook.com"><p>akifsahinkorkmaz@outlook.com</p></a></li>
			
		</ul>
	</nav>
</footer>

<style>
	footer{
		width: 100vw;
		height: 4vh;
		position: absolute;
		bottom: 0;
		left: 0;
		background: rgb(0, 0, 0);
		-webkit-box-shadow: 0px -5px 15px 2px rgba(0,0,0,1);
		-moz-box-shadow: 0px -5px 15px 2px rgba(0,0,0,1);
		box-shadow: 0px -5px 15px 2px rgba(0,0,0,1);
		transition: all 0.3s ease;
		z-index: 60;
	}
	footer:hover, footer:focus{
		height: 6.5vh;
	}
	ul {
		display: flex;
		align-items: flex-start;
		justify-content: center;
		gap: 0.8rem;
		list-style: none;
		font-size: 0.8rem;
		padding: 0;
	}
	ul div{
		display: flex;
		align-items: flex-start;
		justify-content: center;
		gap: 0.8rem;
	}
	ul li img{
		width: 0.8rem;
		height: 0.8rem;
		object-fit: contain;
	}
	ul li a{
		color: white;
		text-decoration: none;
		transition: color 0.3s ease;
		padding: 0;
		margin: 0;
	}
	ul li a p{
		padding: 0;
		margin: 0;
	}
	ul li a:hover{
		color: #FF7A22;
	}
	@media only screen and (max-width: 800px) {
		footer{
			width: 100vw;
			height: 10vh;
			position: absolute;
			bottom: 0;
			left: 0;
			background: rgb(0, 0, 0);
			transition: all 0.3s ease;
			z-index: 60;
		}
		footer:hover, footer:focus{
			height: 15vh;
		}
		ul {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: flex-start;
			gap: 0.8rem;
			list-style: none;
			font-size: 0.8rem;
			padding: 0;
			margin: 0;
			padding-bottom: 1rem;
		}
		li.email{
			margin: 0 10%;
			text-align: center;
		}
	}
</style>
